import React, { ReactNode } from 'react';

import { CardContainer } from './styles';

interface ToolCardProps {
	children: ReactNode;
}

export const ToolCard: React.FC<ToolCardProps> = ({ children }) => <CardContainer>{children}</CardContainer>;
